module.exports = __webpack_public_path__ + "static/img/IMG_20150614_141106.eae04f86.jpg";